import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'managerBuildingAddressFormat'
})
export class ManagerBuildingAddressFormatPipe implements PipeTransform {
  street = '';
  city = '';
  state = '';
  zipCode = '';
  finalValue = '';
  country = '';

  transform(value: any, args?: any): any {

    // value = $(value[0]);
    // console.log(value)
    // console.log(value[0].className);
    let val
    if(value){
      for(var i = 0; i < value.length; i++ ){
        console.log(i, value.length)
        val = $(value[i]);
        console.log(val, "=============================")
        if(val[0].className == "street-address"){
          this.street = val[0].innerHTML;
        }else if(val[0].className == "locality"){
          this.city = val[0].innerHTML
        }else if(val[0].className == "region"){
          this.state = val[0].innerHTML
        }else if(val[0].className == "postal-code"){
          this.zipCode = val[0].innerHTML;
        }else if(val[0].className == "country-name"){
          this.country = val[0].innerHTML;
        }
  
  
        if(i ==  value.length - 1){
          console.log(i, value.length)  
          this.finalValue = "<p>"+this.street+"<br>"+this.city+', '+this.state+' '+this.zipCode+"<br>"+"<span class=\"country\">"+ this.country+"</span>"+"</P>";
          console.log(this.finalValue, '====' ,this.street,this.city, this.zipCode )
          return this.finalValue;
        }
      }
    }

    
  }

}
